

import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold mb-4" style={{ fontFamily: 'Exo 2, sans-serif' }}>
              NBA CIVATA
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Mühendislik ilkeleriyle üreten, kaliteyi standart haline getiren endüstriyel bağlantı elemanları uzmanı.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              <li><Link to="/hakkimizda" className="text-gray-400 hover:text-orange-400 transition-colors">Hakkımızda</Link></li>
              <li><Link to="/urunler" className="text-gray-400 hover:text-orange-400 transition-colors">Ürünler</Link></li>
              <li><Link to="/hizmetler" className="text-gray-400 hover:text-orange-400 transition-colors">Hizmetler</Link></li>
              <li><Link to="/iletisim" className="text-gray-400 hover:text-orange-400 transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">İletişim</h3>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <span>+90 532 550 35 42</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <span>nbacivata@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line"></i>
                <span>Bağlarbaşı Mah. Cemalbey Cad. Irmak Sok. 13/6 Maltepe/İstanbul</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 NBA Cıvata. Tüm hakları saklıdır.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-orange-400 transition-colors text-sm mt-2 md:mt-0 hidden"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}

